import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  *{
    font-family: 'Lato', 'Roboto', sans-serif;
  }
  html,
  body {
    height: 100%;
    width: 100%;
    margin: 0;
    overflow-x: hidden;    
    -webkit-overflow-scrolling: touch;
    /* Disable user text selection for infosec */
    -webkit-user-select: none; /* Safari */
    user-select: none; /* Standard syntax */
  }

  #app {
    background-color: #fff;
    min-height: 100%;
    min-width: 100%;
    height: 100%;
  }
  .image-gallery-thumbnail.active {
    border: 4px solid #FFE500;
  }
  .image-gallery-left-nav:hover::before, .image-gallery-right-nav:hover::before{
    color:#FFE500;
  }
  .tabs *{
    font-weight:900;
  }
  .header-loginbtn{
    padding: 6px 12px !important;
    margin: 9px 0  0 11px !important;
  }
  .left-side .header-loginbtn{
    padding: 6px 12px !important;
    margin: 0 0 0 -6px !important;
    display: inline-block !important;
    vertical-align: super;
  }

  .left-side {
    position: absolute !important;
  }
  ::-ms-clear {
     display: none;
  }
`;

export default GlobalStyle;
